import { useContext } from 'react';
import { createContext } from 'react';

import { ProductImagesProps } from '../@types/ProductImagesProps';

export const ProductImagesContext = createContext<ProductImagesProps>({} as ProductImagesProps);

ProductImagesContext.displayName = 'ProductImages';

const ProductImagesProvider = (props: ProductImagesProps) => (
	<ProductImagesContext.Provider value={props}>{props.children}</ProductImagesContext.Provider>
);

export const useProductImages = () => {
	const context = useContext(ProductImagesContext);

	return context;
};

export default ProductImagesProvider;
